'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CodeContainer = _react2['default'].createClass({
    displayName: 'CodeContainer',


    propTypes: {
        codeStringLines: _react2['default'].PropTypes.array.isRequired,
        classNames: _react2['default'].PropTypes.string
    },

    render: function render() {
        var lines = this.props.codeStringLines.join('\n').replace(/\&quot\;/g, '"');
        return _react2['default'].createElement(
            'pre',
            { className: this.props.classNames },
            lines
        );
    }
});

var CodeTabPaneWithResponse = _react2['default'].createClass({
    displayName: 'CodeTabPaneWithResponse',


    propTypes: {
        languageName: _react2['default'].PropTypes.string.isRequired,
        requestCodeStringLines: _react2['default'].PropTypes.array.isRequired,
        responseCodeStringLines: _react2['default'].PropTypes.array.isRequired,
        containerClassNames: _react2['default'].PropTypes.string,
        codeClassNames: _react2['default'].PropTypes.string,
        isCollapsed: _react2['default'].PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'containerClassNames': '',
            'codeClassNames': '',
            'isCollapsed': true
        };
    },
    getInitialState: function getInitialState() {
        return {
            isCollapsed: this.props.isCollapsed
        };
    },
    toggleResponse: function toggleResponse(evt) {
        evt.preventDefault();
        this.setState({
            'isCollapsed': !this.state.isCollapsed
        });
    },
    render: function render() {

        var classes = [(0, _classnames2['default'])({
            'm-code-example': true,
            'with-response': true,
            'is-collapsed': this.state.isCollapsed
        }), this.props.containerClassNames].join(' ');

        var reqClassNames = [(0, _classnames2['default'])({
            'm-code-example--code': true,
            'prettyprint': true
        }), this.props.codeClassNames].join(' ');

        var respClassNames = [(0, _classnames2['default'])({
            'm-code-example--code--json': true
        }), this.props.codeClassNames].join(' ');

        var request = _react2['default'].createElement(CodeContainer, { classNames: reqClassNames, codeStringLines: this.props.requestCodeStringLines });
        var response = '';

        // TODO: At some point, we'll want to create custom "response" examples
        // for each wrapper. For now, since the response is JSON, let's only display
        // this if the example is using cURL. -Chris (5/21/15)
        if (this.props.languageName === 'curl') {
            response = _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(CodeContainer, { classNames: respClassNames, codeStringLines: this.props.responseCodeStringLines }),
                _react2['default'].createElement(
                    'span',
                    { className: 'm-code-example--expand-link', onClick: this.toggleResponse },
                    _react2['default'].createElement(
                        'span',
                        { className: 'm-code-example--expand-link--dots' },
                        '...'
                    ),
                    _react2['default'].createElement(
                        'a',
                        { className: 'm-code-example--expand-link--link', href: '#' },
                        'Show response'
                    )
                )
            );
        }

        return _react2['default'].createElement(
            'div',
            { className: classes },
            request,
            response
        );
    }
});

module.exports = CodeTabPaneWithResponse;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/code-tab-pane-with-response.jsx
 ** module id = 869
 ** module chunks = 0
 **/